<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" width="1024">
      <v-card>
        <router-link class="noLink" :to="'/CasoUso/' + this.id">
          <v-card-title>
            <span class="text-h5">{{
              conteudoModalDep.isEf
                ? conteudoModalDep.dep_nome
                : conteudoModalDep.csu_nome
            }}</span>
          </v-card-title>
        </router-link>
        <div>
          <v-container>
            {{
              conteudoModalDep.isEf
                ? conteudoModalDep.dep_nome
                : conteudoModalDep.csu_nome
            }}
            <v-icon icon="mdi-chevron-right" />
            {{ conteudoModalDep.tipo_dependencia }}
            <v-icon icon="mdi-chevron-right" />
            {{
              !conteudoModalDep.isEf
                ? conteudoModalDep.dep_nome
                : conteudoModalDep.csu_nome
            }}
          </v-container>
        </div>
        <v-card-text>
          <v-container>
            {{
              conteudoModalDep.isEf
                ? conteudoModalDep.dep_descricao
                : conteudoModalDep.csu_descricao
            }}
          </v-container>
        </v-card-text>

        <v-card-actions v-if="isDev">
          <v-spacer></v-spacer>

          Deseja excluir a relação de dependência entre
          <span class="strn">{{ conteudoModalDep.csu_nome }} </span>
          e <span class="strn"> {{ conteudoModalDep.dep_nome }}</span>
          <v-btn @click="deleteDep" color="red" append-icon="mdi-delete-outline"
            >Excluir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import axios from 'axios';

import store from '@/store/store';
export default {
  props: {
    dialogDep: Boolean,
    toggleShowDialogDep: Function,
    conteudoModalDep: Object,
  },
  data: () => ({
    dialog: false,
    id: null,
  }),
  mounted() {
    this.dialog = this.dialogDep;
    // this.id = this.conteudoModalDep.isEf
    //   ? this.conteudoModalDep.id_dependencia_eferente
    //   : this.conteudoModalDep.id_caso_de_uso;

    // this.dialogDep = false;
    // console.log(this.conteudoModalDep);
    // console.log(this.dialog);

    // this.$router.push('/CasoUso/7');
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    dialogDep(newDialog, _oldDialog) {
      if (newDialog == true) {
        this.dialog = newDialog;
        this.id = this.conteudoModalDep.isEf
          ? this.conteudoModalDep.id_dependencia_eferente
          : this.conteudoModalDep.id_caso_de_uso;
        this.toggleShowDialogDep();
      }
    },
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  methods: {
    async deleteDep() {
      const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

      try {
        const result = await axios.delete(
          apiUrl + '/api/v1/productBacklog/dependencia',
          {
            data: {
              // eslint-disable-next-line camelcase
              id_caso_de_uso: this.conteudoModalDep.id_caso_de_uso,
              // eslint-disable-next-line camelcase
              id_dependencia_eferente:
                this.conteudoModalDep.id_dependencia_eferente,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.dialog = false;
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.noLink {
  text-decoration: none;
  color: inherit;
}
/* .noLink:hover {
  text-decoration: underline;
  color: rgba(0, 0, 0, 0.826);
} */
.strn {
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 700;
  text-decoration: underline;
}
</style>
